export default __webpack_public_path__ + "cb6f363edaf48777693145729a842de6.woff";